var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.AKPriceSOTODifferentPercent ? _c('div', [_c('feather-icon', {
    class: "text-warning cursor-pointer ".concat(_vm.svgClass),
    attrs: {
      "id": "IAmAlertAKPriceSOTODifferentPercent-".concat(_vm.uid),
      "icon": "InfoIcon",
      "size": _vm.iconSize
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "IAmAlertAKPriceSOTODifferentPercent-".concat(_vm.uid),
      "triggers": "hover focus",
      "boundary": "window",
      "custom-class": "tooltip_class",
      "variant": "light"
    }
  }, [_c('span', {
    staticClass: "fw-700"
  }, [_vm._v(" " + _vm._s(_vm.$t("flight.AKPriceSOTODifferentPercent", {
    AKPriceSOTODifferentPercent: _vm.AKPriceSOTODifferentPercent
  })) + " ")])])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }